import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'cpb-label-input',
  templateUrl: './label-input.component.html',
})
export class CapturumBuilderLabelInputComponent extends FieldType {
}
